import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dep0302CtlrOut } from 'app/core/models/api/dep/dep0302'

const initialState: Pick<
    Dep0302CtlrOut,
    'allPdcd' | 'pdfAddList' | 'nfchOfrPdm'
> & { rqstCd: string } = {
    allPdcd: '',
    nfchOfrPdm: '',
    pdfAddList: [],
    rqstCd: '',
}

const slice = createSlice({
    name: 'productDetail',
    initialState,
    reducers: {
        clearProductDetail: () => initialState,
        setProductDetail: (state, action: PayloadAction<Dep0302CtlrOut>) => {
            state.allPdcd = action.payload.allPdcd
            state.nfchOfrPdm = action.payload.nfchOfrPdm
            state.pdfAddList = action.payload.pdfAddList
        },
        setProductDetails: (
            state,
            action: PayloadAction<Partial<typeof initialState>>
        ) => {
            Object.keys(action.payload).map((key) => {
                state[key] = action.payload[key]
            })
        },
    },
})

export const { clearProductDetail, setProductDetail, setProductDetails } =
    slice.actions

export default slice.reducer
